<button #button (click)="emitClickButton($event)" type="button" class="btn {{ btnSizeClass }}"
        [attr.aria-label]="ariaLabel || buttonText"
        [disabled]="isDisabled" [ngClass]="{'disabled': isDisabled, 'btn-secondary': isSecondary,'btn-primary': isPrimary, 'btn-red': isRed}"
        title="{{buttonText}}">
  {{buttonText}}
  <ng-content></ng-content>
</button>
